<template>
	<v-dialog
		v-if="alarm"
		v-model="dialog"
		v-bind="$attrs"
		persistent
		:fullscreen="$vuetify.breakpoint.xsOnly"
		scrollable
	>
		<v-card :tile="$vuetify.breakpoint.xsOnly">
			<template v-if="!loading && !currentStep">
				<v-card-title> {{ strings.missing }} </v-card-title>
				<v-card-text></v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialog = false">{{
						strings.close
					}}</v-btn>
				</v-card-actions>
			</template>
			<template v-else>
				<v-card-title v-text="deviceAlarm(alarm)" />
				<v-card-subtitle v-text="deviceAlarmType(alarm)" />
				<v-card-text class="d-flex flex-column justify-center text-center">
					<p>{{ stepText }}</p>

					<div v-if="loading">
						<p v-if="currentStep">{{ currentStep.testText }}</p>
						<v-progress-circular indeterminate></v-progress-circular>
					</div>
					<div v-else-if="!!currentStep.action">
						<v-btn
							v-if="!failure && !success"
							color="primary"
							tile
							outlined
							@click="triggerTest(currentStep)"
							>Test</v-btn
						>
						<div v-else-if="success">
							<h3 class="success--text">Success!</h3>
							<span>{{ strings.postSuccess }}</span>
						</div>
						<div v-else>
							<span>{{ failure }}</span>
							<span v-if="!isLastStep"> {{ strings.postFail }}</span>
						</div>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-row dense>
						<v-col class="d-flex align-end">
							<v-btn color="primary" text :disabled="loading" @click="goBack">{{
								backStepText
							}}</v-btn>
						</v-col>
						<v-col class="d-flex justify-center">
							<div>
								<v-btn id="notes-btn" color="primary" text @click="viewNotes">
									<div class="d-flex flex-column" style="gap: 4px">
										<v-icon class="mr-1" color="unset">fas fa-clipboard</v-icon>
										<span>{{ strings.notes }}</span>
									</div>
								</v-btn>
							</div>
						</v-col>
						<v-col class="d-flex justify-end align-end">
							<v-btn
								color="primary"
								text
								:disabled="disableNextStep"
								@click="nextStep"
								>{{ nextStepText }}</v-btn
							>
						</v-col>
					</v-row>
				</v-card-actions>
			</template>
		</v-card>

		<NotesDialog :key="alarm.id" ref="NotesDialog" max-width="600" />
	</v-dialog>
</template>

<script>
import _ from "lodash";
import { alarmTypes } from "../status";
import { mapActions, mapGetters } from "vuex";
import strings from "@/utils/strings";

export default {
	components: {
		NotesDialog: () => import("./NotesDialog.vue"),
	},

	data() {
		return {
			dialog: false,
			alarm: null,
			step: 0,
			lastStep: -1,
			strings: strings.k4noc.alarms.wizard,
		};
	},

	computed: {
		...mapGetters("tickets/fixWizard", [
			"loading",
			"success",
			"failure",
			"steps",
			"wizard",
			"stepText",
		]),

		backStepText() {
			return this.step ? this.strings.goBack : this.strings.close;
		},

		isLastStep() {
			return this.step === this.lastStep || this.success;
		},

		nextStepText() {
			return this.isLastStep ? this.strings.confirm : this.strings.nextStep;
		},

		disableNextStep() {
			return (
				this.loading ||
				(!!this.currentStep.action && !(this.failure || this.success))
			);
		},

		currentStep() {
			return this.steps[this.step];
		},
	},

	watch: {
		currentStep(step) {
			this.$store.commit("tickets/fixWizard/setStep", step);
			this.lastStep = this.steps.length - 1;
		},

		isLastStep(val) {
			if (val) {
				this.$emit("reload");
			}
		},

		dialog(val) {
			if (!val && this.failure) {
				this.$emit("reload");
			}
		},
	},

	methods: {
		...mapActions("tickets/fixWizard", ["close"]),
		capitalize: _.capitalize,

		pop(alarm) {
			this.step = 0;
			this.alarm = alarm;
			this.$store.commit("tickets/fixWizard/reset");
			if (alarm) {
				this.$store.dispatch("tickets/fixWizard/loadWizard", alarm);
			}
			this.dialog = true;
		},

		deviceAlarm(item) {
			return item.path.replace("Devices/", "").replaceAll("/", " ");
		},

		deviceAlarmType(item) {
			if (!item) return "";
			const alarm = alarmTypes.find((alarm) => alarm.value === item.alarm_type);
			return _.get(alarm, "text", item.alarm_type);
		},

		async triggerTest(step) {
			await this.$store.dispatch("tickets/fixWizard/" + step.action);
		},

		goBack() {
			if (!this.step) {
				this.close();
				this.dialog = false;
				return;
			}
			this.step--;
		},
		viewNotes() {
			this.$refs.NotesDialog.pop();
		},
		nextStep() {
			if (this.isLastStep) {
				this.close();
				this.dialog = false;
				return;
			}
			this.step++;
		},
	},
};
</script>

<style lang="scss" scoped>
#notes-btn {
	height: 54px;
}
</style>
